import styled from 'styled-components'

const Styled = styled.div`
.ant-picker {
    border-radius: 10px;
    min-width: 100%;
  }

.impact-select {
    width: 250px;
}

.legend-vertical{
  transform: rotate(270deg);
  padding-left:30px;
  font-weight: bold;
  height:50px
}
.legend-horizontal {
  padding-top: 30px;
  font-weight: bold;
}

.label-horizontal {
  padding: 20px 0px;
}
.label-vertical {
  padding: 0px 20px;
}

td{
  text-align:center;
}
.risk-chart {
  display: flex;
  justify-content: center;
}

.box {
  margin: 10px;
  background: #f2f3f7;
  width: 100px;
  height: 100px;
  cursor: pointer; 
}
.box:hover {
  filter: brightness(0.5);
}

.active {
  filter: brightness(0.7);
  box-shadow: rgb(0 0 0 / 15%) 5px 9px 10px 0px;
  border-radius:10px; 
}
table { 
  border-spacing: 10px;
  border-collapse: separate;
}
`

export default Styled
